import React from 'react';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { AnalyticsEventSender } from '@alfa-bank/site-analytics-event-sender/analytics-event-sender';
import { TagDesktop as Tag } from '@alfa-bank/site-tag/desktop';
import cn from 'classnames';

import type { IMainHeaderPublicProps } from '../../models';

import styles from './styles.css';

type TSuggestBlockProps = Pick<IMainHeaderPublicProps, 'suggestList' | 'suggestTitle'>;

export const SuggestBlock = ({ suggestList, suggestTitle }: TSuggestBlockProps) => {
    const goToSearch = (link: string) => {
        // eslint-disable-next-line check-window-access/check-window-access
        window.location.assign(link);
    };

    return (
        <div className={styles.container}>
            <Block
                className={cn(styles.external, styles.suggestBlock)}
                dataTestId={'suggest-block'}
                styler={{ padding: 16 }}
                theme="lightInverted"
            >
                <Text
                    kind="secondaryInverted"
                    styler={{ marginBottom: 12, marginTop: 0 }}
                    tag="div"
                    view="primary-medium"
                >
                    {suggestTitle}
                </Text>
                <div className={cn(styles.suggestContainer)}>
                    {suggestList?.map(({ analytics, link, title }) => (
                        <AnalyticsEventSender
                            key={title}
                            $events={{
                                onClick: analytics,
                            }}
                        >
                            <Tag
                                dataTestId={title}
                                label={title}
                                onClick={() => goToSearch(link)}
                                role="link"
                                size="xs"
                                styler={{ margin: 0 }}
                                theme="lightInverted"
                                value={title}
                            />
                        </AnalyticsEventSender>
                    ))}
                </div>
            </Block>
        </div>
    );
};
